import { call, put, takeEvery } from "redux-saga/effects";
import { 
  FETCHING_SKILLS_FAILED, 
  FETCHING_SKILLS_REQUEST, 
  FETCHING_SKILLS_SUCCEEDED, 
  INVALIDATE_SKILLS, 
  SEARCHING_SKILLS_FAILED, 
  SEARCHING_SKILLS_REQUEST, 
  SEARCHING_SKILLS_SUCCEEDED, 
  UPDATE_SKILLS_PREFERENCES_REQUEST, 
  UPDATING_SKILLS_PREFERENCES_SUCCEEDED, 
  UPDATING_SKILLS_PREFERENCES_FAILED, 
  CREATING_SKILL_REQUEST,
  CREATING_SKILL_SUCCEEDED,
  CREATING_SKILL_FAILED,
  UPDATING_SKILL_REQUEST,
  UPDATING_SKILL_SUCCEEDED,
  UPDATING_SKILL_FAILED,
  INVALIDATE_UPDATE_SKILL,
  INVALIDATE_CREATE_SKILL,
  DELETING_SKILL_REQUEST,
  DELETING_SKILL_SUCCEEDED,
  DELETING_SKILL_FAILED,
  INVALIDATE_DELETE_SKILL,
  FETCH_ASSESSMENT_CONFIGURATIONS_REQUEST,
  FETCHING_ASSESSMENT_CONFIGURATIONS_SUCCEEDED,
  FETCHING_ASSESSMENT_CONFIGURATIONS_FAILED
} from "../actionTypes";

import { createAction } from "@reduxjs/toolkit";

import { 
  CreateSkillErrorResponse, 
  CreateSkillRequest, 
  CreateSkillResponse, 
  DeleteSkillErrorResponse, 
  DeleteSkillResponse, 
  FetchSkillsErrorResponse, 
  FetchSkillsRequest, 
  FetchSkillsResponse, 
  SearchSkillsErrorResponse, 
  SearchSkillsRequest, 
  SearchSkillsResponse, 
  UpdateSkillPreferencesErrorResponse, 
  UpdateSkillPreferencesRequest, 
  UpdateSkillPreferencesResponse 
} from "src/types/coaching/skills";

import axios from "axios";
import buildUrl from "build-url-ts";
import { UpdateSkillErrorResponse, UpdateSkillRequest, UpdateSkillResponse } from "../../../types/coaching/skills";
import { FetchDefaultAssessmentConfigurationErrorResponse, FetchDefaultAssessmentConfigurationResponse } from "src/types/coaching/assessmentConfiguration";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_COACHING_API_URL}`;

//Fetch Skills
export const fetchSkills = createAction<FetchSkillsRequest>(FETCHING_SKILLS_REQUEST);
const fetchingSkillsSucceeded = createAction<FetchSkillsResponse>(FETCHING_SKILLS_SUCCEEDED);
const fetchingSkillsFailed = createAction<FetchSkillsErrorResponse>(FETCHING_SKILLS_FAILED);

const fetchSkillsSaga = function* (action: ReturnType<typeof fetchSkills>): any {
  const { query, parent, page, limit } = action.payload as FetchSkillsRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/skills`,
    queryParams: {
      query: query,
      parent: parent,
      page: page,
      limit: limit,
    }
  });

  const fetchSkillsAPI = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchSkillsAPI);
    yield put(fetchingSkillsSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingSkillsFailed({ error: error }));
  }
};

//search skills
export const searchSkills = createAction<SearchSkillsRequest>(SEARCHING_SKILLS_REQUEST);
const searchingSkills = createAction<SearchSkillsResponse>(SEARCHING_SKILLS_SUCCEEDED);
const searchingSkillsFailed = createAction<SearchSkillsErrorResponse>(SEARCHING_SKILLS_FAILED);

const searchSkillsSaga = function* (action: ReturnType<typeof searchSkills>): any {

  const { query, parent, page, limit } = action.payload as SearchSkillsRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/skills`,
    queryParams: {
      query: query,
      parent: parent,
      page: page,
      limit: limit,
    }
  });

  const searchSkillsAPI = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(searchSkillsAPI);
    yield put(searchingSkills({
      response: response
    }));

  } catch (error) {
    yield put(searchingSkillsFailed({ error: error }));
  }
}

/**
 * Creating Skill
 */
export const createSkill = createAction<CreateSkillRequest>(CREATING_SKILL_REQUEST);
const creatingSkillSucceeded = createAction<CreateSkillResponse>(CREATING_SKILL_SUCCEEDED);
const creatingSkillFailed = createAction<CreateSkillErrorResponse>(CREATING_SKILL_FAILED);

const createSkillSaga = function* (action: ReturnType<typeof createSkill>): any {
  const request = action.payload as CreateSkillRequest;

  const url = buildUrl(apiUrl, {
    path: `/api/1.0/skills`,

  });

  const createSkillsAPI = () => {
    return axios({
      method: 'POST',
      url: url,
      data: request,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createSkillsAPI);
    yield put(creatingSkillSucceeded({ skill: response }));
  } catch (error) {
    yield put(creatingSkillFailed({ error: error }));
  }
};

export const invalidateCreateSkill = createAction<void>(INVALIDATE_CREATE_SKILL);

/**
 * Updating Skill
 */
export const updateSkill = createAction<UpdateSkillRequest>(UPDATING_SKILL_REQUEST);
const updatingSkillSucceeded = createAction<UpdateSkillResponse>(UPDATING_SKILL_SUCCEEDED);
const updatingSkillFailed = createAction<UpdateSkillErrorResponse>(UPDATING_SKILL_FAILED);

const updateSkillSaga = function* (action: ReturnType<typeof updateSkill>): any {
  const request = action.payload as UpdateSkillRequest;

  const url = buildUrl(apiUrl, {
    path: `/api/1.0/skills/${request.id}`,

  });

  const updateSkillsAPI = () => {
    return axios({
      method: 'PUT',
      url: url,
      data: request,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateSkillsAPI);
    yield put(updatingSkillSucceeded({ skill: response }));
  } catch (error) {
    yield put(updatingSkillFailed({ error: error }));
  }
};

export const invalidateUpdateSkill = createAction<void>(INVALIDATE_UPDATE_SKILL);

/**
 * Delete Skill
 */
export const deleteSkill = createAction<string>(DELETING_SKILL_REQUEST);
const deletingSkillSucceeded = createAction<DeleteSkillResponse>(DELETING_SKILL_SUCCEEDED);
const deletingSkillFailed = createAction<DeleteSkillErrorResponse>(DELETING_SKILL_FAILED);

const deleteSkillSaga = function* (action: ReturnType<typeof deleteSkill>): any {
  const id = action.payload as string;

  const url = buildUrl(apiUrl, {
    path: `/api/1.0/skills/${id}`,
  });

  const deleteSkillsAPI = () => {
    return axios({
      method: 'DELETE',
      url: url
    }).then((response) => response.data);
  };

  try {
    yield call(deleteSkillsAPI);
    yield put(deletingSkillSucceeded({ id: id }));
  } catch (error) {
    yield put(deletingSkillFailed({ error: error }));
  }
};

export const invalidateDeleteSkill = createAction<void>(INVALIDATE_DELETE_SKILL);

//Update skills preference
export const updateSkillsPreference = createAction<UpdateSkillPreferencesRequest>(UPDATE_SKILLS_PREFERENCES_REQUEST);
const updatingSkillsPreferenceSucceeded = createAction<UpdateSkillPreferencesResponse>(UPDATING_SKILLS_PREFERENCES_SUCCEEDED);
const updatingSkillsPreferenceFailed = createAction<UpdateSkillPreferencesErrorResponse>(UPDATING_SKILLS_PREFERENCES_FAILED);

const updateSkillPreferencesSaga = function* (action: ReturnType<typeof updateSkillsPreference>): any {
  const { skills } = action.payload as UpdateSkillPreferencesRequest;

  const url = buildUrl(apiUrl, {
    path: `api/1.0/explore/skill_preferences`,

  });

  const updateSkillsAPI = () => {
    return axios({
      method: 'PUT',
      url: url,
      data: skills,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateSkillsAPI);
    yield put(updatingSkillsPreferenceSucceeded({ response: response }));
  } catch (error) {
    yield put(updatingSkillsPreferenceFailed({ error: error }));
  }
};

export const invalidateSkills = createAction<void>(INVALIDATE_SKILLS);

export const fetchAssessmentConfigurations = createAction<void>(FETCH_ASSESSMENT_CONFIGURATIONS_REQUEST);
const fetchingAssessmentConfigurationsSucceeded = createAction<FetchDefaultAssessmentConfigurationResponse>(FETCHING_ASSESSMENT_CONFIGURATIONS_SUCCEEDED);
const fetchingAssessmentConfigurationsFailed = createAction<FetchDefaultAssessmentConfigurationErrorResponse>(FETCHING_ASSESSMENT_CONFIGURATIONS_FAILED);

const fetchAssessmentConfigurationsSaga = function* (action: ReturnType<typeof fetchAssessmentConfigurations>): any {

  const fetchAssessmentConfigurationAPI = () => {
    return axios({
      method: "GET",
      url: `${apiUrl}/api/1.0/simulations/assessment/configurations`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssessmentConfigurationAPI);
    yield put(
      fetchingAssessmentConfigurationsSucceeded({response})
    );
  } catch (error) {
    yield put(
      fetchingAssessmentConfigurationsFailed({
        error: error,
      })
    );
  }
};


export default function* skillsSagas() {
  yield takeEvery(FETCHING_SKILLS_REQUEST, fetchSkillsSaga);
  yield takeEvery(SEARCHING_SKILLS_REQUEST, searchSkillsSaga);
  yield takeEvery(CREATING_SKILL_REQUEST, createSkillSaga);
  yield takeEvery(UPDATING_SKILL_REQUEST, updateSkillSaga);
  yield takeEvery(DELETING_SKILL_REQUEST, deleteSkillSaga);
  yield takeEvery(UPDATE_SKILLS_PREFERENCES_REQUEST, updateSkillPreferencesSaga);
  yield takeEvery(FETCH_ASSESSMENT_CONFIGURATIONS_REQUEST, fetchAssessmentConfigurationsSaga);
}